import * as yup from "yup";

export const CitySetupValidationSchema = yup.object().shape({
  provinceState: yup
  .string()
  .required("Province is required"),
	name: yup
    .string()
    .max(100, "Maximum length 100 characters"),
});
